import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NavBarItem } from './NavBarItem'

export type NavBarMenuIconProps = {
  icon: IconDefinition
  label: string
  toggled: boolean
  onClick: () => void
}

export const NavBarMenuIcon = (props: NavBarMenuIconProps) => {
  return (
    <NavBarItem {...props} style={{ width: 'auto', flex: '0 0 auto' }}>
      <FontAwesomeIcon
        icon={props.icon}
        fontSize={'1.9375rem'}
        color={props.toggled ? 'var(--brand-secondary)' : 'var(--palette-blue-300)'}
      />
    </NavBarItem>
  )
}
